import { i18n } from '../../../../internationalize/i18n.service'
import { ChartRouterComponent } from '../../..';
// @ts-ignore
import styleCSS from "./chart-tabs.style.scss?inline"

export class ChartTabsComponent extends HTMLElement {
    private _shadowRoot: ShadowRoot;
    private _chartContainer!: HTMLDivElement;
    private _chartIds!: string[];
    private _chartTypes!: string[];
    private _tabsContainer!: HTMLDivElement;

    constructor() {
        super();
        this._shadowRoot = this.attachShadow({ mode: "open" });
    }

    connectedCallback() {
        this.init();

        const style = document.createElement('style');
        style.textContent = styleCSS;
        this._shadowRoot.appendChild(style);
    }

    init() {
        this._chartIds = this.getAttribute('ids')?.split(',') || [];
        this._chartTypes = this.getAttribute('types')?.split(',') || [];
        this.setGUI()
    }

    setGUI() {
        this._tabsContainer = document.createElement('div') as HTMLDivElement
        this._tabsContainer.classList.add('tabs-wrapper')
        this.createTabs(this._tabsContainer)
        this._shadowRoot.appendChild(this._tabsContainer)
        this._chartContainer = document.createElement('div') as HTMLDivElement
        this._chartContainer.classList.add('chart-container')
        this._shadowRoot.appendChild(this._chartContainer)

        this.createChart(this._chartIds[0], this._chartContainer, this._chartTypes[0])
        const firstTab = this._tabsContainer.firstChild as HTMLButtonElement
        firstTab.classList.add('active')
    }

    private createTabs(container: HTMLDivElement) {
        this._chartIds.forEach((t: string) => {
            const tab = document.createElement('button')
            tab.setAttribute('chart-type', t)
            tab.innerHTML = `
            <p class="tab-button-text">${i18n.t(t)}</p>
            `
            tab.classList.add('tab-button')
            tab.addEventListener('click', () => {
                this.onClickTab(tab)
                window.tbwServices.analyticsService.track("dashboard_tab_click")
            })
            container.appendChild(tab)
        })
    }

    private onClickTab(tab: HTMLButtonElement) {
        if (tab.classList.contains('active')) {
            return;
        }

        this._chartContainer.innerHTML = ''
        this._tabsContainer.querySelectorAll('button').forEach((t: HTMLButtonElement) => {
            t.classList.remove('active')
        })
        tab.classList.add('active')

        const chartTypeIndex = this._chartIds.indexOf(tab.getAttribute('chart-type') || '')
        this.createChart(tab.getAttribute('chart-type') || '', this._chartContainer, this._chartTypes[chartTypeIndex])
    }

    private createChart(id: string, container: HTMLDivElement, type: string) {
        const chart = new ChartRouterComponent();
        chart.setAttribute('chart-type', id);
        chart.setAttribute('series-type', type || 'Stacked Area');
        container.appendChild(chart);
    }
}
